<template>
  <v-list-item :to="item.link" color="primary" dense exact>
    <v-list-item-icon class="mr-2">
      <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title style="font-size: 15px" v-text="item.label" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'SidebarListItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
